export default {
	countryCode: "Código de país",
};
